import React from "react";
import clsx from "clsx";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { colorSystem } from "../../theme";
import frame from "../../assets/iphone-frame.jpeg";

const PHONE_DISPLAY_RATIO = 0.5;

const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: theme.spacing(2),
    color: theme.palette.border.primary,
  },
  phone: {
    width: "100%",
    maxWidth: theme.spacing(18),
    aspectRatio: `${PHONE_DISPLAY_RATIO} / 1`,
    background: `url(${frame}) no-repeat`,
    backgroundPositionY: "bottom",
    backgroundSize: "cover",
    pointerEvents: "none",
    userSelect: "none",
  },
  screen: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "97%",
    margin: "2%",
    borderColor: colorSystem.black,
    borderRadius: `15% / ${PHONE_DISPLAY_RATIO * 15}%`,
    borderWidth: theme.spacing(0.25),
  },
  splash: {
    width: "50%",
    aspectRatio: "1 / 1",
    objectFit: "contain",
  },

  paddingTop: {
    paddingTop: "0.5%",
  },
}));

export interface IphoneSplashPreviewProps {
  splashUrl: string;
  paddingTop?: boolean;
}

export function IphoneSplashPreview(props: IphoneSplashPreviewProps) {
  const { splashUrl, paddingTop = true } = props;
  const s = useStyles();

  return (
    <Box className={clsx(s.phone, paddingTop && s.paddingTop)}>
      <Box className={s.screen}>
        {splashUrl && (
          <img className={s.splash} src={splashUrl} alt="Splash Screen" />
        )}
      </Box>
    </Box>
  );
}
